window.YTQueue = {
  hasRun: false,
  queuedItems: [],
  run: function run() {
    this.queuedItems.forEach(function (item) {
      return item();
    });
    this.queuedItems = [];
    this.hasRun = true;
    window.youtubeLoaded = true;
  },
  queueItem: function queueItem(item) {
    // eslint-disable-next-line no-unused-expressions
    this.hasRun ? item() : this.queuedItems.push(item);
  }
};

window.onYouTubeIframeAPIReady = function () {
  return window.YTQueue.run();
};